var u = Object.defineProperty;
var d = (s, i, e) => i in s ? u(s, i, { enumerable: !0, configurable: !0, writable: !0, value: e }) : s[i] = e;
var o = (s, i, e) => (d(s, typeof i != "symbol" ? i + "" : i, e), e);
class p {
  transformOptions(i) {
    return process.env.LEAD_GENERATOR_APPLICATION_ID && (i.headers.ConsumerApplication = process.env.LEAD_GENERATOR_APPLICATION_ID), process.env.GATSBY_LEAD_GENERATOR_APPLICATION_ID && (i.headers.ConsumerApplication = process.env.GATSBY_LEAD_GENERATOR_APPLICATION_ID), process.env.GATSBY_COMMUNICATION_KEY && (i.headers["communication-key"] = process.env.GATSBY_COMMUNICATION_KEY), Promise.resolve(i);
  }
}
class _ extends p {
  constructor(e, t) {
    super();
    o(this, "http");
    o(this, "baseUrl");
    o(this, "jsonParseReviver");
    this.http = t || window, this.baseUrl = e ?? "";
  }
  /**
   * Get health temp
   * @return Payload of TempResponse
   */
  getHealthTemp() {
    let e = this.baseUrl + "/health";
    e = e.replace(/[?&]$/, "");
    let t = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    };
    return this.transformOptions(t).then((n) => this.http.fetch(e, n)).then((n) => this.processGetHealthTemp(n));
  }
  processGetHealthTemp(e) {
    const t = e.status;
    let n = {};
    return e.headers && e.headers.forEach && e.headers.forEach((r, a) => n[a] = r), t === 200 ? e.text().then((r) => {
      let a = null;
      return a = r === "" ? null : JSON.parse(r, this.jsonParseReviver), a;
    }) : t !== 200 && t !== 204 ? e.text().then((r) => h("An unexpected server error occurred.", t, r, n)) : Promise.resolve(null);
  }
  /**
   * Get health
   * @return Payload of Dictionary of String
   */
  getHealth(e) {
    let t = this.baseUrl + "/health/{application}";
    if (e == null)
      throw new Error("The parameter 'application' must be defined.");
    t = t.replace("{application}", encodeURIComponent("" + e)), t = t.replace(/[?&]$/, "");
    let n = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    };
    return this.transformOptions(n).then((r) => this.http.fetch(t, r)).then((r) => this.processGetHealth(r));
  }
  processGetHealth(e) {
    const t = e.status;
    let n = {};
    return e.headers && e.headers.forEach && e.headers.forEach((r, a) => n[a] = r), t === 200 ? e.text().then((r) => {
      let a = null;
      return a = r === "" ? null : JSON.parse(r, this.jsonParseReviver), a;
    }) : t !== 200 && t !== 204 ? e.text().then((r) => h("An unexpected server error occurred.", t, r, n)) : Promise.resolve(null);
  }
  /**
   * Get maintenance
   * @param application lg or czone
   * @return Payload of Array of MaintenanceObjectDto
   */
  getMaintenance(e) {
    let t = this.baseUrl + "/maintenance/{application}";
    if (e == null)
      throw new Error("The parameter 'application' must be defined.");
    t = t.replace("{application}", encodeURIComponent("" + e)), t = t.replace(/[?&]$/, "");
    let n = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    };
    return this.transformOptions(n).then((r) => this.http.fetch(t, r)).then((r) => this.processGetMaintenance(r));
  }
  processGetMaintenance(e) {
    const t = e.status;
    let n = {};
    return e.headers && e.headers.forEach && e.headers.forEach((r, a) => n[a] = r), t === 200 ? e.text().then((r) => {
      let a = null;
      return a = r === "" ? null : JSON.parse(r, this.jsonParseReviver), a;
    }) : t !== 200 && t !== 204 ? e.text().then((r) => h("An unexpected server error occurred.", t, r, n)) : Promise.resolve(null);
  }
  /**
   * Add maintenance
   * @param application lg or czone
   * @param maintenanceInput (optional) 
   * @return Payload of MaintenanceObjectDto
   */
  addMaintenance(e, t) {
    let n = this.baseUrl + "/maintenance/{application}";
    if (e == null)
      throw new Error("The parameter 'application' must be defined.");
    n = n.replace("{application}", encodeURIComponent("" + e)), n = n.replace(/[?&]$/, "");
    let a = {
      body: JSON.stringify(t),
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    return this.transformOptions(a).then((l) => this.http.fetch(n, l)).then((l) => this.processAddMaintenance(l));
  }
  processAddMaintenance(e) {
    const t = e.status;
    let n = {};
    return e.headers && e.headers.forEach && e.headers.forEach((r, a) => n[a] = r), t === 200 ? e.text().then((r) => {
      let a = null;
      return a = r === "" ? null : JSON.parse(r, this.jsonParseReviver), a;
    }) : t !== 200 && t !== 204 ? e.text().then((r) => h("An unexpected server error occurred.", t, r, n)) : Promise.resolve(null);
  }
  /**
   * Delete maintenance
   * @param application lg or czone
   * @return No description
   */
  deleteMaintenance(e, t) {
    let n = this.baseUrl + "/maintenance/{application}/{maintenanceId}";
    if (e == null)
      throw new Error("The parameter 'application' must be defined.");
    if (n = n.replace("{application}", encodeURIComponent("" + e)), t == null)
      throw new Error("The parameter 'maintenanceId' must be defined.");
    n = n.replace("{maintenanceId}", encodeURIComponent("" + t)), n = n.replace(/[?&]$/, "");
    let r = {
      method: "DELETE",
      headers: {}
    };
    return this.transformOptions(r).then((a) => this.http.fetch(n, a)).then((a) => this.processDeleteMaintenance(a));
  }
  processDeleteMaintenance(e) {
    const t = e.status;
    let n = {};
    return e.headers && e.headers.forEach && e.headers.forEach((r, a) => n[a] = r), t === 204 ? e.text().then((r) => {
    }) : t !== 200 && t !== 204 ? e.text().then((r) => h("An unexpected server error occurred.", t, r, n)) : Promise.resolve(null);
  }
  /**
   * Edit maintenance
   * @param application lg or czone
   * @param maintenanceInput (optional) 
   * @return Payload of MaintenanceObjectDto
   */
  editMaintenance(e, t, n) {
    let r = this.baseUrl + "/maintenance/{application}/{maintenanceId}";
    if (e == null)
      throw new Error("The parameter 'application' must be defined.");
    if (r = r.replace("{application}", encodeURIComponent("" + e)), t == null)
      throw new Error("The parameter 'maintenanceId' must be defined.");
    r = r.replace("{maintenanceId}", encodeURIComponent("" + t)), r = r.replace(/[?&]$/, "");
    let l = {
      body: JSON.stringify(n),
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    return this.transformOptions(l).then((c) => this.http.fetch(r, c)).then((c) => this.processEditMaintenance(c));
  }
  processEditMaintenance(e) {
    const t = e.status;
    let n = {};
    return e.headers && e.headers.forEach && e.headers.forEach((r, a) => n[a] = r), t === 200 ? e.text().then((r) => {
      let a = null;
      return a = r === "" ? null : JSON.parse(r, this.jsonParseReviver), a;
    }) : t !== 200 && t !== 204 ? e.text().then((r) => h("An unexpected server error occurred.", t, r, n)) : Promise.resolve(null);
  }
}
var f = /* @__PURE__ */ ((s) => (s.LG = "LG", s.CZone = "CZone", s))(f || {}), m = /* @__PURE__ */ ((s) => (s.LG = "LG", s.CZone = "CZone", s))(m || {}), E = /* @__PURE__ */ ((s) => (s.LG = "LG", s.CZone = "CZone", s))(E || {});
class v extends Error {
  constructor(e, t, n, r, a) {
    super();
    o(this, "message");
    o(this, "status");
    o(this, "response");
    o(this, "headers");
    o(this, "result");
    o(this, "isApiException", !0);
    this.message = e, this.status = t, this.response = n, this.headers = r, this.result = a;
  }
  static isApiException(e) {
    return e.isApiException === !0;
  }
}
function h(s, i, e, t, n) {
  throw n ?? new v(s, i, e, t, null);
}
export {
  v as ApiException,
  f as Application,
  m as Application2,
  E as Application3,
  _ as HealthApiClient,
  p as HealthApiClientBase
};
